import { Injectable } from '@angular/core';
import { BaseClient } from '../common/client/base.client';
import { SvcClients } from '../common/client/SvcClients';

@Injectable({
  providedIn: 'root',
})
export class HelpClient extends BaseClient {
  constructor() {
    super();
  }

  //#region SUPPORT

  registerSupportTicket(message: string, model: any) {
    return this.post(
      SvcClients.AdminSvc,
      `UserTicket/CreateUserTicket`,
      model,
      message
    );
  }

  // readReceipts=true: HasUnreadMessages is computed per viewer from read receipts (#28957)
  // instead of the per-ticket CRM flag. PDP is the only client that has adopted them.
  getTicketsForUser(message: string, filter: string = 'mine', customerCode?: number) {
    let url = `UserTicket/GetTicketsForUser?filter=${filter}&readReceipts=true`;
    if (customerCode) {
      url += `&customerCode=${customerCode}`;
    }
    return this.get(
      SvcClients.AdminSvc,
      url,
      message
    );
  }

  getTicketsForAllLocations(message: string) {
    return this.get(
      SvcClients.AdminSvc,
      `UserTicket/GetTicketsForAllLocations?readReceipts=true`,
      message
    );
  }

  getSupportBadgeCount() {
    return this.get(
      SvcClients.AdminSvc,
      `UserTicket/GetSupportBadgeCount`,
      ''
    );
  }

  getTicketCommunication(message: string, ticketId: string) {
    return this.get(
      SvcClients.AdminSvc,
      `UserTicket/GetTicketCommunication?ticketId=${ticketId}`,
      message
    );
  }

  replyToTicket(message: string, ticketId: string, model: any) {
    return this.post(
      SvcClients.AdminSvc,
      `UserTicket/ReplyToTicket?ticketId=${ticketId}`,
      model,
      message
    );
  }

  takeOverTicket(message: string, ticketId: string, model: any) {
    return this.post(
      SvcClients.AdminSvc,
      `UserTicket/TakeOverTicket?ticketId=${ticketId}`,
      model,
      message
    );
  }

  markTicketAsRead(message: string, ticketId: string, model: any) {
    return this.post(
      SvcClients.AdminSvc,
      `UserTicket/MarkTicketAsRead?ticketId=${ticketId}`,
      model,
      message
    );
  }

  // Per-viewer read receipts (#28957): { Messages: [{ MessageId, CreatedOn }] }
  markMessagesRead(ticketId: string, model: any) {
    return this.post(
      SvcClients.AdminSvc,
      `UserTicket/MarkMessagesRead?ticketId=${ticketId}`,
      model,
      ''
    );
  }

  downloadAttachment(annotationId: string, source?: string) {
    let url = `UserTicket/DownloadAttachment?annotationId=${annotationId}`;
    if (source) {
      url += `&source=${source}`;
    }
    return this.downloadFile(SvcClients.AdminSvc, url);
  }

  setTicketPin(ticketId: string, isPinned: boolean) {
    return this.post(
      SvcClients.AdminSvc,
      `UserTicket/SetTicketPin?ticketId=${ticketId}`,
      { IsPinned: isPinned },
      ''
    );
  }

  setTicketFlag(ticketId: string, isFlagged: boolean) {
    return this.post(
      SvcClients.AdminSvc,
      `UserTicket/SetTicketFlag?ticketId=${ticketId}`,
      { IsFlagged: isFlagged },
      ''
    );
  }

  //#endregion SUPPORT

  //#region SCHEDULE TRAINING
  GetAvailableTimes(
    message: string,
    serviceName: string,
    date: any,
    customerCode: number
  ) {
    // return this.get(SvcClients.CrmProxyApi, `ServiceActivity/ServiceAvailableTimesGet?ServiceName=${serviceName}&Date=${dt.toISOString().substr(0, 19)}&MinutesOffset=${-dt.getTimezoneOffset()}`, message);
    let dt = new Date(date);
    return this.get(
      SvcClients.AdminSvc,
      `UserTicket/GetAvailableTimes?serviceName=${serviceName}&date=${dt
        .toISOString()
        .substr(0, 19)}&minutesOffset=${dt.getTimezoneOffset()}`,
      message
    );
  }

  scheduleTraining(
    message: string,
    model: any,
    customerCode: number,
    userCode: number
  ) {
    return this.post(
      SvcClients.AdminSvc,
      `UserTicket/ScheduleTraining?customerCode=${customerCode}&userCode=${userCode}`,
      model,
      message
    );
  }

  //#endregion SCHEDULE TRAINING
}
